import React, { useRef } from 'react';

const useSkipUpdate = (initialValue = true) => {
  const skip = useRef(initialValue);

  const shouldSkipUpdate = () => {
    if (skip.current) {
      skip.current = false;
      return true;
    }
    return false;
  };

  const skipUpdate = () => {
    skip.current = true;
  };

  const publicAPI = { shouldSkipUpdate, skipUpdate };

  return publicAPI;
};

export default useSkipUpdate;
